import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

interface ChannelParamCollectionOptions {
    moduleId: number
}

export class ChannelParamCollection extends CachingCollection<Backbone.Model> {

    moduleId: number;

    url = () => {
        return window.location.origin + '/api/v1/module/' + this.moduleId + '/channelparams';
    };

    constructor(initialModels: Object[] | any[], options: ChannelParamCollectionOptions) {
        super(initialModels, options);
        this.moduleId = options.moduleId;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/ChannelParams.ts